"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _PublicTagSelect = _interopRequireDefault(require("../public-tag/PublicTagSelect"));

var _DropdownSelectize = require("@insided/shared/uikit/dropdown/DropdownSelectize");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Edit = _interopRequireDefault(require("@insided/shared/icons/Edit"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicPublicTags = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicPublicTags, _Component);

  var _super = _createSuper(TopicPublicTags);

  function TopicPublicTags() {
    var _this$props$tags;

    var _this;

    (0, _classCallCheck2.default)(this, TopicPublicTags);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "savedTags", (_this$props$tags = _this.props.tags) !== null && _this$props$tags !== void 0 ? _this$props$tags : []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isPublicTagManagementEnabled", _common.common.isModuleActive('publicTagDestination'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isThreadedRepliesEnabled", _common.common.isModuleActive('threadedRepliesDestination'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      editEnabled: false,
      tags: _this.props.tags,
      isLoading: false,
      alert: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      _this.props.onChange(_this.savedTags);

      _this.setState({
        editEnabled: false,
        tags: _this.savedTags,
        alert: null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAlert", function (type, message) {
      _this.setState({
        alert: {
          type: type,
          message: message !== null && message !== void 0 ? message : 'Changes could not be applied'
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TopicPublicTags, [{
    key: "onChangePublicTags",
    value: function () {
      var _onChangePublicTags = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _e$response, _e$response$data, _e$response2, _e$response2$data;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.post("/community/api/".concat(this.props.contentType, "s/").concat(this.props.topicId, "/editTags"), {
                  tags: this.state.tags
                });

              case 4:
                this.savedTags = this.state.tags;
                this.props.onChange(this.savedTags);
                this.setState({
                  isLoading: false,
                  editEnabled: false,
                  tags: this.savedTags,
                  alert: null
                });
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                this.handleShowAlert('error', (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.field) === 'tags' ? (0, _preact.h)(_phrase.default, {
                  m: "Content",
                  p: _context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response2 = _context.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.description
                }) : null);
                this.setState({
                  isLoading: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9]]);
      }));

      function onChangePublicTags() {
        return _onChangePublicTags.apply(this, arguments);
      }

      return onChangePublicTags;
    }()
  }, {
    key: "getButtonTitle",
    value: function getButtonTitle() {
      var _this$props$usePlainT = this.props.usePlainTextLabels,
          usePlainTextLabels = _this$props$usePlainT === void 0 ? false : _this$props$usePlainT;
      var tags = this.state.tags;
      var hasExistingTags = tags.length > 0;

      if (usePlainTextLabels) {
        return hasExistingTags ? 'Edit tags' : 'Add tags';
      }

      return hasExistingTags ? (0, _preact.h)(_phrase.default, {
        p: "tags.edit",
        m: "Forum"
      }) : (0, _preact.h)(_phrase.default, {
        p: "tags.add",
        m: "Forum"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          canUserEdit = _this$props.canUserEdit,
          _this$props$canEndUse = _this$props.canEndUserAddPublicTags,
          canEndUserAddPublicTags = _this$props$canEndUse === void 0 ? true : _this$props$canEndUse,
          usePlainTextLabels = _this$props.usePlainTextLabels;
      var _this$state = this.state,
          tags = _this$state.tags,
          editEnabled = _this$state.editEnabled,
          isLoading = _this$state.isLoading,
          alert = _this$state.alert;
      return (0, _preact.h)("div", {
        className: "topic-public-tags-list m-v"
      }, !editEnabled ? (0, _preact.h)("ul", {
        className: (0, _classnames.default)('public-tags', 'list', 'list--float', 'js-collapsable--content', 'qa-tags-list')
      }, tags.map(function (tag, i) {
        return (0, _preact.h)("li", {
          key: i
        }, usePlainTextLabels ? (0, _preact.h)("span", {
          className: "tag--pill qa-tag-pill"
        }, tag) : (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/search?q=".concat(encodeURIComponent(tag), "&search_type=tag")),
          className: "tag--pill qa-tag-pill"
        }, tag));
      }), canUserEdit && (this.isThreadedRepliesEnabled ? (0, _preact.h)(_SubtleButton.default, {
        startIcon: (0, _preact.h)(_Edit.default, {
          width: 14,
          height: 14
        }),
        onClick: function onClick() {
          return _this2.setState({
            editEnabled: true
          });
        },
        title: this.getButtonTitle()
      }) : (0, _preact.h)("li", {
        className: "canEditTags",
        onClick: function onClick() {
          return _this2.setState({
            editEnabled: true
          });
        }
      }, (0, _preact.h)(_Add.default, {
        width: 14,
        height: 14
      }), (0, _preact.h)(_phrase.default, {
        p: "Modify tags"
      })))) : (0, _preact.h)("div", {
        className: "public-tag-edit"
      }, (alert === null || alert === void 0 ? void 0 : alert.message) && (0, _preact.h)("div", {
        className: "box box--alert"
      }, (0, _preact.h)(_AlertComponent.default, {
        messageType: "error",
        message: alert.message,
        showCloseButton: false
      })), this.isPublicTagManagementEnabled ? (0, _preact.h)(_PublicTagSelect.default, {
        isEdit: false,
        onChange: function onChange(newTags) {
          return _this2.setState({
            tags: newTags,
            alert: null
          });
        },
        selectedPublicTags: tags,
        inputName: "form-control qa-topic-creator-public-tags-input",
        canEndUserAddPublicTags: canEndUserAddPublicTags,
        iconSize: 12,
        placeholder: usePlainTextLabels ? 'Add tags' : (0, _translations.translate)('Forum', 'tags.add')
      }) : (0, _preact.h)(_DropdownSelectize.DropdownSelectizeInput, {
        items: [],
        single: false,
        class: "form-control qa-topic-creator-public-tags-input",
        placeholder: "Add tags to help readers easily find this product update",
        selectedItems: tags !== null && tags !== void 0 && tags.length ? tags : tags || [],
        onChange: function onChange(newTags) {
          return _this2.setState({
            tags: newTags,
            alert: null
          });
        }
      }), (0, _preact.h)("div", {
        className: "public-tag-edit-buttons"
      }, (0, _preact.h)(_Button.default, {
        qaClasses: (0, _classnames.default)('btn', 'js-collapsable--trigger', 'btn--S', 'qa-button-tags-cancel', this.isThreadedRepliesEnabled ? 'btn-secondary' : 'btn--cancel'),
        cancel: true,
        onClick: function onClick() {
          return _this2.onCancel();
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "Cancel",
        m: "Forum"
      })), (0, _preact.h)(_Button.default, {
        loading: isLoading,
        qaClasses: "btn btn--S btn--cta save-public-tag qa-button-tags-save",
        primary: true,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.onChangePublicTags();

                case 2:
                  return _context2.abrupt("return", _context2.sent);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      }, (0, _preact.h)(_phrase.default, {
        p: "Save",
        m: "Forum"
      })))));
    }
  }]);
  return TopicPublicTags;
}(_preact.Component);

var _default = TopicPublicTags;
exports.default = _default;